/**
 * How to round a percentage-derived deposit to the configured increment.
 */
export enum PercentageDepositRoundingModeEnum {
	NEAREST = 'nearest',
	UP = 'up',
	DOWN = 'down',
}
